// extracted by mini-css-extract-plugin
module.exports = {"categoryName":"categoryName___UkjM5","category":"category___3JAhC"};